/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ManageSecurityMatrixModel {
        public securityMatrixs: Wars.Domain.Model.SecurityMatrix[];
        private systemLevel: Wars.Domain.Model.SystemLevel;
        public selectedSecurityMatrix: Wars.Domain.Model.SecurityMatrix;
        public processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        public sortBy: string = 'name';
        public search: any;

        private isSystemLevel: boolean;

        constructor(
            public processConfigurationId: string,
            private securityMatrixService: services.SecurityMatrixService,
            private systemLevelService: services.SystemLevelService,
            private deleteService: services.DeleteService,
            private processConfigurationService: services.ProcessConfigurationService)
        {
            this.search = {
                name: ''
            }

            if (processConfigurationId) {
                this.isSystemLevel = false;
                processConfigurationService.getById(processConfigurationId).then(p => {
                  this.processConfiguration = p;
                });
                this.securityMatrixService.getProcessConfigurationSecurityMatrices(processConfigurationId)
                    .then(r => {
                        this.securityMatrixs = r;
                    });
            } else {
                this.isSystemLevel = true;
                this.systemLevelService.getSystemLevelSecurityMatrices()
                    .then(r => {
                        this.systemLevel = r;
                        this.securityMatrixs = r.mySecurityMatrices;
                    });
            }
        }

        public save() {
            this.securityMatrixService.saveAllChanges();
        }

        public addSecurityRow() {
            this.selectedSecurityMatrix = this.securityMatrixService.createSecurityRow(this.isSystemLevel);
            this.addMatrix();
        }

        public addSecurityRowWithSubTypes() {
            this.selectedSecurityMatrix = this.securityMatrixService.createSecurityRowWithSubTypes(this.isSystemLevel);
            this.addMatrix();
        }

        public addAdvancedSecurityMatrix() {
            this.selectedSecurityMatrix = this.securityMatrixService.createAdvancedSecurityMatrix(this.isSystemLevel);
            this.addMatrix();
        }

        public delete() {
            this.deleteService.deleteWithModalConfirmIfNecessary("SecurityMatrix",
                this.selectedSecurityMatrix.id,
                "Security Matrix",
                () => {
                    this.securityMatrixs.remove(this.selectedSecurityMatrix);
                    this.selectedSecurityMatrix = null;
                });
        }

        private addMatrix() {
            this.selectedSecurityMatrix.name = '';
            if (this.systemLevel) {
                this.selectedSecurityMatrix.systemLevel = this.systemLevel;
                this.selectedSecurityMatrix.systemLevel_id = this.systemLevel.id;
                this.selectedSecurityMatrix.isSystemLevel = true;
            } else {
                this.selectedSecurityMatrix.processConfiguration_id = this.processConfigurationId;
                this.selectedSecurityMatrix.isSystemLevel = false;
            }

            this.securityMatrixs.push(this.selectedSecurityMatrix);
            this.securityMatrixService.saveAllChanges();
        }

        public addSecurityMatrix() {
            this.selectedSecurityMatrix = this.securityMatrixService.createSecurityMatrix(this.isSystemLevel);
            this.addMatrix();
        }

        public viewSecurityMatrix(matrix: Wars.Domain.Model.SecurityMatrix): void {
            this.securityMatrixService.openViewSecurityMatrixModal(matrix.id);
        }

        public copySecurityMatrix(matrix: Wars.Domain.Model.SecurityMatrix): void {
            var newSecurityMatrix: Wars.Domain.Model.SecurityMatrix;

            switch (matrix.matrixType) {
                case Wars.Domain.Model.Codes.Enums.SecurityMatrixType.HideOrReadOnlyOrUpdateable:
                    newSecurityMatrix = this.securityMatrixService.createAdvancedSecurityMatrix(this.isSystemLevel, matrix.alwaysVisible);
                    break;
                case Wars.Domain.Model.Codes.Enums.SecurityMatrixType.HideOrShow:
                    newSecurityMatrix = this.securityMatrixService.createSecurityMatrix(this.isSystemLevel, matrix.alwaysVisible);
                    break;
                case Wars.Domain.Model.Codes.Enums.SecurityMatrixType.SecurityRow:
                    newSecurityMatrix = this.securityMatrixService.createSecurityRow(this.isSystemLevel, matrix.alwaysVisible);
                    break;
                case Wars.Domain.Model.Codes.Enums.SecurityMatrixType.SecurityRowWithSubType:
                    newSecurityMatrix = this.securityMatrixService.createSecurityRowWithSubTypes(this.isSystemLevel, matrix.alwaysVisible);
                    break;
            }
            
            newSecurityMatrix.alwaysVisible = matrix.alwaysVisible;
            newSecurityMatrix.usesAnotherSecurityMatrix = matrix.usesAnotherSecurityMatrix;
            newSecurityMatrix.reusedSecurityMatrix = matrix.reusedSecurityMatrix;
            newSecurityMatrix.securityMatrix_id = matrix.securityMatrix_id;
            newSecurityMatrix.name = matrix.name + ' (Copy)';
            newSecurityMatrix.uniqueIdentifier = services.UtilityService.generateGuidComb();
            newSecurityMatrix.systemLevel_id = matrix.systemLevel_id;
            newSecurityMatrix.systemLevel = matrix.systemLevel;
            newSecurityMatrix.processConfiguration = matrix.processConfiguration;
            newSecurityMatrix.processConfiguration_id = matrix.processConfiguration_id;
            newSecurityMatrix.claimTreeItemsJson = matrix.claimTreeItemsJson;
            newSecurityMatrix.matrixJson = matrix.matrixJson;
            newSecurityMatrix.condition = matrix.condition;
            newSecurityMatrix.condition_id = matrix.condition_id;

            this.save();

            this.selectedSecurityMatrix = newSecurityMatrix;
        }
    }
}